/* eslint-disable react/jsx-props-no-spreading */
import { Box, InputLabel } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';

import './Dropzone.css';

interface DropZoneProps {
  label?: string;
  selectedFiles: File[];
  onFileChange: (files: File[]) => void;
  clearFiles: (clearFunc: () => void) => void;
}

const DropZone: FC<DropZoneProps> = ({
  label = '',
  selectedFiles,
  onFileChange,
  clearFiles,
}) => {
  const [currentFiles, setCurrentFiles] = useState<File[]>(selectedFiles);

  const onDrop = (files: File[]) => {
    if (files.length > 0) {
      setCurrentFiles(files);
      onFileChange(files);
    }
  };

  useEffect(() => {
    clearFiles(() => {
      setCurrentFiles([]);
    });
  }, [clearFiles]);

  return (
    <>
      {label && <InputLabel>{label}: </InputLabel>}
      <Dropzone onDrop={onDrop} multiple>
        {({ getRootProps, getInputProps }) => (
          <Box className="dropzone-styles" {...getRootProps()}>
            <input {...getInputProps()} />
            {currentFiles &&
            Array.isArray(currentFiles) &&
            currentFiles.length ? (
              <Box className="selected-file">
                {currentFiles.length > 3
                  ? `${currentFiles.length} files`
                  : currentFiles.map((file) => file.name).join('\r\n')}
              </Box>
            ) : (
              'Drag and drop files here, or click to select files'
            )}
          </Box>
        )}
      </Dropzone>
    </>
  );
};

export default DropZone;
